<template>
  <div
    class="create-edit-easy-edit"
    ref="refCreateEditEasyEdit"
    :class="`create-edit-easy-edit--${createRenderType}`"
    @mousewheel="onMouseWheel"
  >
    <div class="create-edit-easy-edit-input">
      <InputPrompt
        v-if="renderData.ifRender"
        ref="refInputPrompt"
        :placeholder="renderData.defaultIdea"
        v-model:idea="renderData.idea"
        @change="onChangeIdea"
        @input="onInputIdea"
      ></InputPrompt>
    </div>

    <div class="create-edit-easy-edit-btn">
      <div
        class="create-basic-ai-identification"
        v-if="globalConfig.appname == chinaAppName"
      >
        {{ $$t("editor.create_ai_identification") }}
      </div>
      <Button
        v-if="createRenderType != 'mobile'"
        :disabled="renderData.disabled"
        @click="
          () => {
            doGernerate()
          }
        "
        :loading="renderData.isLoading"
        :renderStyle="{
          '--padding': '0',
          '--width': '100%',
          '--height': '48px',
          '--borderRadius': '48px',
          '--background':
            'linear-gradient(97deg, rgba(79, 222, 255, 1) 0%, rgba(230, 117, 255, 1) 99%)',
          '--fontColor': '#000',
          '--fontSize': '16px',
          '--fontWeight': '500',
          '--border': 'none',
          '--backgroundHover':
            'linear-gradient(97deg, rgba(79, 222, 255, 0.75) 0%, rgba(230, 117, 255, 0.75) 99%)',
          '--fontColorHover': '#000',
        }"
      >
        <div class="flex-center btn-content">
          <span>{{ $$t("create.create") }}</span>
          <div
            class="create-submit-button-model-use-first fn-inline"
            v-if="modelDataStore.current_model?.free_to_use ?? 0"
          >
            {{ $$t("create.first_free") }}
          </div>
        </div>
      </Button>
      <Button
        v-if="createRenderType == 'mobile'"
        @click="
          () => {
            doGernerate()
          }
        "
        :disabled="renderData.disabled"
        :loading="renderData.isLoading"
        :renderStyle="{
          '--padding': '0',
          '--width': '100%',
          '--height': '56px',
          '--borderRadius': '56px',
          '--background':
            'linear-gradient(97deg, rgba(79, 222, 255, 1) 0%, rgba(230, 117, 255, 1) 99%)',
          '--fontColor': '#fff',
          '--fontSize': '16px',
          '--fontWeight': '500',
          '--border': 'none',
          '--backgroundHover':
            'linear-gradient(97deg, rgba(79, 222, 255, 0.75) 0%, rgba(230, 117, 255, 0.75) 99%)',
          '--fontColorHover': '#fff',
        }"
      >
        <div class="flex-center btn-content">
          <span class="ico fn-inline"></span>
          <span class="fn-inline">{{ $$t("create.create") }}</span>
          <div
            class="create-submit-button-model-use-first fn-inline"
            v-if="modelDataStore.current_model?.free_to_use ?? 0"
          >
            {{ $$t("create.first_free") }}
          </div>
        </div>
      </Button>
    </div>

    <div class="create-edit-easy-edit-style">
      <StyleRefer
        v-if="renderData.mounted"
        @switchStyle="doSwitchStyle"
      ></StyleRefer>
    </div>
    <div class="create-edit-easy-edit-idears-box flex1 height-0">
      <CreateIdeas
        :defaultIdea="renderData.defaultIdea"
        @clickItem="onClickItem"
        :idea="renderData.idea"
        @initIdeaDatas="initIdeaDatas"
      ></CreateIdeas>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"
import { storeToRefs } from "pinia"

import globalConfig, {
  getGuidanceJsonDataUrl,
  chinaAppName,
} from "@/config/config.js"
import tools from "@/utils/tools.js"
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js"
import { $$language, $$t, $$tValue } from "@/i18n/i18n.js"

import Button from "@/components/basic/button/Button.vue"
import InputPrompt from "./inputPrompt.vue"
import CreateIdeas from "./createIdeas.vue"
import StyleRefer from "./styleRefer.vue"
import { showActionDialog } from "@/components/functionCallComponent/action/action.js"

import useFeedListStore from "@/store/create/feedListDataStore.js"
import useUserDataStore from "@/store/userDataStore.js"

import useCreateEasyModeStore from "@/store/create/createEasyModeStore.js"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
import usePresetSourceDataStore from "@/store/create/presetSourceDataStore.js"
import useGlobalUserStateStore from "@/store/globalUserStateStore.js"
import useModelDataStore from "@/store/model/modelDataStore.js"

const createLayoutStore = useCreateLayoutStore()
const feedListDataStore = useFeedListStore()
const createEasyModeStore = useCreateEasyModeStore()
const userDataStore = useUserDataStore()
const presetSourceDataStore = usePresetSourceDataStore()
const globalUserStateStore = useGlobalUserStateStore()
const modelDataStore = useModelDataStore()
const { createRenderType } = storeToRefs(createLayoutStore)

const props = defineProps({
  similarData: {
    type: Object,
    default: () => {
      return null
    },
  },
})
const emits = defineEmits([])
const stateData = {}
const refInputPrompt = ref(null)
const refCreateEditEasyEdit = ref(null)

const renderData = reactive({
  mounted: false,
  disabled: false,
  idea: "",
  isLoading: false,
  ifRender: true,
  presetIdeas: [],
})

const onMouseWheel = (e) => {
  // if (e.deltaY > 0) {
  //   console.log("向下滚动", e.deltaY);
  // } else {
  //   console.log("向上滚动", e.deltaY);
  // }
}

const onChangeIdea = (e) => {
  renderData.idea = e
}
const onInputIdea = (e) => {
  renderData.idea = e
}

const onClickItem = (item) => {
  refInputPrompt.value?.insertText(item)
}

const doGernerate = async (isInit) => {
  const globalProperties = (
    getCurrentInstance() || window?.$getVueCurrentInstance?.()
  ).appContext?.config?.globalProperties
  const preset =
    Object.values(createEasyModeStore.genresPromptmaps_all ?? {}).some(
      (clist) => {
        return clist.some((item) => {
          return item?.content == renderData.idea
        })
      }
    ) || !renderData.idea
      ? "1"
      : createEasyModeStore.randomPromptData?.content == renderData.idea
      ? "3"
      : "2"

  globalProperties?.logClickEvent("create_basic_mode_create", {
    prompt: renderData.idea ?? "",
    preset: preset,
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    tab_stare: createLayoutStore.createModeGuideTabState
      ? "guide_switch"
      : "switch",
    source: modelDataStore.current_model?.model,
    is_self:
      modelDataStore.current_model?.uid &&
      modelDataStore.current_model?.uid ==
        userDataStore?.userInfo?.user?.user_id
        ? 1
        : 0,
  })

  if (
    // "generate", "0"
    !(await userDataStore.checkLoginStatus(
      {
        rightType: "generate",
        create_type: "0",
        generate: "0",
      },
      (isLogin) => {
        if (isLogin) {
          performGenerate(true)
        }
        console.log("doGernerate_easymode")
        localStorage.removeItem(`${globalConfig.appname}_create_data`)
      }
    ))
  ) {
    localStorage.setItem(
      `${globalConfig.appname}_create_data`,
      JSON.stringify({
        type: "easymode",
        timeScamps: new Date().getTime(),
        prompt: renderData.idea,
      })
    )
    globalProperties?.logClickEvent("newuser_create_easymode", {
      type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    })
    return
  }
  performGenerate(isInit)
}

const performGenerate = async (isInit, isAlert = true) => {
  const model = modelDataStore.current_model
  if (
    modelDataStore.current_model?.need_credit_alert &&
    (modelDataStore.current_model?.free_to_use ?? 0) <= 0 &&
    isAlert &&
    !props.similarData
  ) {
    showActionDialog({
      content: !modelDataStore.current_model?.uid
        ? $$t("editor.o1_model_create_alert")
        : $$tValue("editor.user_model_create_alert", {
            credits: modelDataStore.current_model?.required_credits,
            songcount: 2,
          }),
      cancelLabel: $$t("create.cancel"),
      confirmLabel: $$t("create.create"),
      titleAlign: "left",
      confirm: (closeAction) => {
        closeAction()
        performGenerate(isInit, false)
        modelDataStore.changeCurrentModelAlertState(model, false)
      },
      cancel: (closeAction) => {
        closeAction?.()
        modelDataStore.changeCurrentModelAlertState(model, false)
      },
    })
  } else {
    if (!props.similarData) {
      if (!globalUserStateStore.setBasicModeClickedGuidVisible("hard")) {
        // modelDataStore.showChooseModelPop();
      }
    }
    renderData.isLoading = true
    feedListDataStore
      .doGenerateEasyMode(isInit, null, {
        membership_source1: "create",
        membership_source2: props.similarData
          ? "create_basic_similar"
          : "create_basic",
      })
      .then((res) => {
        renderData.isLoading = false
        modelDataStore.changeFreeState(model)
        // setTimeout(() => {
        //   if (
        //     createLayoutStore.createEditMode != "hard" &&
        //     !props.similarData
        //   ) {
        //     globalUserStateStore.showBasicModeClickedGuidVisible("hard");
        //   }
        // }, 3000);
      })
      .catch((err) => {
        renderData.isLoading = false
        console.log(err)
      })
  }
}
const initEvent = () => {
  let transLeft = 0
  stateData.registTouchWaveBarSwipeCall = tools.registTouchSwipe(
    refCreateEditEasyEdit.value,
    {
      direction: "horizontal",
      startCb: (e, actionData) => {
        if (!stateData.touchSwipeState) {
          stateData.touchSwipeState = true
        }
      },
      moveCb: (e, actionData) => {
        const { startX, endX } = actionData
        const dx = Math.floor(endX - startX)
      },
      endCb: (e, actionData) => {
        if (stateData.touchSwipeState) {
          stateData.touchSwipeState = false
        }
      },
    }
  )
}

// const getDemoIdeasData = () => {
//   return new Promise((resolve, reject) => {
//     presetSourceDataStore
//       .getPresetSourceData()
//       .then((data) => {
//         // stateData.demoIdeasData = data.prompts;
//         stateData.demoIdeasData =
//           data.web_song_showcase?.map((item) => {
//             return item.prompt;
//           }) ??
//           data.prompts ??
//           [];
//         resolve();
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };

const reRender = () => {
  renderData.ifRender = false
  nextTick(() => {
    renderData.ifRender = true
  })
}
const initIdeaDatas = (datas) => {
  renderData.defaultIdea = datas[0]?.content ?? $$t("create.idear_placehoder")
  createEasyModeStore.setDefaultPromptData(datas[0]?.content ?? "")
}
const initPresetIdeas = (data) => {
  //  getDemoIdeasData()
  // .then(() => {
  stateData.demoIdeasData =
    data?.web_song_showcase?.map((item) => {
      return item.prompt
    }) ??
    data.prompts ??
    []
  let defaultIdea =
    stateData.demoIdeasData[
      Math.floor(Math.random() * stateData.demoIdeasData.length)
    ] ?? $$t("create.idear_placehoder")
  createEasyModeStore.setDefaultPromptData(defaultIdea ?? "")
  renderData.defaultIdea = defaultIdea
  renderData.presetIdeas = stateData.demoIdeasData
    .map((item) => {
      return {
        content: item,
      }
    })
    .filter((item) => {
      return item.content != defaultIdea
    })
  reRender()

  // })
  // .catch((err) => {
  //   renderData.defaultIdea = $$t("create.idear_placehoder");
  // });
}

const init = () => {
  if (createEasyModeStore.defaultPromptData?.content) {
    renderData.defaultIdea = createEasyModeStore.defaultPromptData.content
    return
  }
  // if (presetSourceDataStore.presetSourceData) {
  //   initPresetIdeas(presetSourceDataStore.presetSourceData);
  // }
}

const doSwitchStyle = (style) => {}

// watch(
//   () => {
//     return presetSourceDataStore.presetSourceData;
//   },
//   () => {
//     if (presetSourceDataStore.presetSourceData) {
//       initPresetIdeas(presetSourceDataStore.presetSourceData);
//     }
//   }
// );

watch(
  () => {
    return renderData.idea
  },
  () => {
    // renderData.disabled = renderData.idea?.length;
    createEasyModeStore.setPromptDataContent(renderData.idea)
  }
)
watch(
  () => {
    return createEasyModeStore.easyPromptData
  },
  () => {
    renderData.idea = createEasyModeStore.easyPromptData?.content
  }
)

watch(
  () => {
    return userDataStore.isLogin
  },
  () => {
    renderData.userCredits = userDataStore.isLogin
      ? userDataStore.credits ?? 0
      : 6
  }
)
const initGenerate = () => {
  console.log("initGenerate_easymode0")

  if (userDataStore.isLogin) {
    let _create_data = localStorage.getItem(
      `${globalConfig.appname}_create_data`
    )
    try {
      _create_data = JSON.parse(_create_data)
      if (_create_data) {
        if (new Date().getTime() - _create_data?.timeScamps < 1000 * 60 * 60) {
          if (_create_data?.type == "easymode") {
            nextTick(() => {
              createEasyModeStore.setPromptDataContent(
                _create_data.prompt || ""
              )
              renderData.idea = _create_data?.prompt || ""
            }).then(() => {
              localStorage.removeItem(`${globalConfig.appname}_create_data`)
              performGenerate(true)
              createLayoutStore.toggleCreateEditOpenState(true)
              createLayoutStore.setCreateEditMode("easy")
            })
          }
        }
      } else {
        _create_data = null
        localStorage.removeItem(`${globalConfig.appname}_create_data`)
      }
    } catch (e) {
      _create_data = null
      localStorage.removeItem(`${globalConfig.appname}_create_data`)
    }
  } else {
    localStorage.removeItem(`${globalConfig.appname}_create_data`)
  }
}
watch(
  () => {
    return userDataStore.isLogin
  },
  () => {
    if (userDataStore.isLogin) {
      nextTick(() => {
        setTimeout(() => {
          initGenerate()
        }, 20)
      })
    }
  }
)

onMounted(() => {
  nextTick().then(() => {
    renderData.mounted = true
    if (userDataStore.isLogin) {
      initGenerate()
    }
  })
  renderData.idea = createEasyModeStore.easyPromptData?.content ?? ""
  init()
  initEvent()
})
</script>
<style lang="scss">
.create-edit-easy-edit {
  height: 100%;
  // background: rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  .create-edit-easy-edit-input {
    min-height: 150px;
    flex: 0.4 1 0;
  }
  .create-edit-easy-edit-style {
    margin: 0 0 12px 0;
  }
  .create-edit-easy-edit-idears-box {
    flex: 0.6 1 0;
    height: 0;
  }
  .create-edit-easy-edit-btn {
    width: 100%;
    padding: 16px 0px 24px 0;
    display: flex;
    flex-direction: column;
    .create-basic-ai-identification {
      margin: 0 0 12px 0;
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 0.5);
      text-transform: capitalize;
      text-align: left;
    }
    .custom-button {
      height: max-content;
      min-height: max-content;
    }
    .btn-content {
      position: relative;
    }
    .create-submit-button-model-use-first {
      position: absolute;
      top: -8px;
      left: 110%;
      height: 22px;
      padding: 0 8px 0 8px;
      border-radius: 16px 20px 20px 0px;
      /* 自动布局 */
      display: flex;
      flex-direction: column;
      background: linear-gradient(
        112deg,
        #ffe08b 0%,
        #fff7d0 47%,
        #ffe08b 100%
      );
      line-height: 22px;
      font-family: HarmonyOS Sans SC;
      font-size: 10px;
      font-weight: 400;
      color: #000;
    }
    .custom-button .el-button.is-disabled {
      opacity: 0.5 !important;
    }
    .el-button {
      .el-icon.is-loading {
        background-image: url(@/assets/img/loading-mini-white-3x.png) !important;
      }
    }

    span.ico {
      width: 20px;
      height: 20px;
      background-image: url("@/assets/img/music-ico-white.png");
      background-size: 100% 100%;
      margin-right: 5px;
    }
    .create-submit-button-disabled {
      // opacity: 0.3;
    }
  }
  &.create-edit-easy-edit--mobile {
    .create-edit-easy-edit-btn {
      .el-button {
        background-image: url("@/assets/img/create-btn-bg.png");
        background-size: 100% 100%;
      }
      .create-submit-button-model-use-first {
        position: absolute;
        top: -5px;
        left: 105%;
      }
      .create-basic-ai-identification {
        text-align: center;
      }
    }
    .create-edit-easy-edit-input {
      min-height: 150px;
      flex: 0.35 1 0;
    }
    .create-edit-easy-edit-idears-box {
      flex: 0.65 1 0;
      height: 0;
    }
  }
}
</style>
